import { selectBasketIsEmpty, selectBasketIsUnpresentedRentedWarehouses } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { getMissingRequiredInfo, updateOAuth } from 'containers/Login/loginSlice'
import { getRedirectPath } from 'utils/redirect'
import { useHistory } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

type AuthType = 'apple' | 'google'

const useAuth = (type: AuthType) => {
  const isUnpresentedRentedWarehouses = useReduxSelector(selectBasketIsUnpresentedRentedWarehouses)
  const isBasketEmpty = useReduxSelector(selectBasketIsEmpty)
  const currentData = useRef({ isBasketEmpty, isUnpresentedRentedWarehouses })
  currentData.current.isUnpresentedRentedWarehouses = isUnpresentedRentedWarehouses
  currentData.current.isBasketEmpty = isBasketEmpty

  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  useEffect(() => {
    const getAuth = async (_search: string, _type: AuthType) => {
      try {
        const params = new URLSearchParams(_search)
        const body = Object.fromEntries(params.entries())
        const response = await POST(`${urls.oauth}/${_type}`, { body })
        const redirect = getRedirectPath()
        dispatch(updateOAuth(response))
        replace(getMissingRequiredInfo(response)
          ? '/registration'
          : currentData.current.isBasketEmpty
            ? currentData.current.isUnpresentedRentedWarehouses
              ? '/newwarehouse'
              : (redirect || '/dashboard')
            : '/order/billing'
        )
      } catch (error) {
        replace('/login')
      }
    }

    if (window.location.search && type) {
      getAuth(window.location.search, type)
    } else {
      replace('/login')
    }
  }, [dispatch, replace, type])
}

export default useAuth